<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('specie.species') }}</h2>
    </div>
    <el-card v-if="checkRole(['Admin'])" class="box-card filter-card just-for-admin">
      <div slot="header" class="clearfix">
        <span>{{ $t('general.filter') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="initSearch">{{ $t('general.init') }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio v-model="activeList" label="actives" border @change="getSubSpeciesList('indexactive')">{{ $t('general.F_actives') }}</el-radio>
        <el-radio v-model="activeList" label="desactives" border @change="getSubSpeciesList('indexdesactive')">{{ $t('general.F_desactives') }}</el-radio>
        <el-radio v-model="activeList" label="disponibles" border @change="handleFilterSpecies">{{ $t('general.disponibles') }}</el-radio>
        <el-radio v-model="activeList" label="corbeille" class="danger-radio" border @change="getSubSpeciesList('indexinvisible')">{{ $t('general.corbeille') }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input v-model="query.keyword" clearable :placeholder="$t('general.keyword')" class="wd-200 mr-15 filter-item" @keyup.enter.native="handleFilterSpecies" />
        <el-select
          v-model="query.diseases"
          class="filter-item"
          filterable
          clearable
          multiple
          :placeholder="$t('disease.disease')"
          @change="handleFilterSpecies"
        >
          <el-option
            v-for="(disease, index) in diseases"
            :key="index"
            :label="disease.name | uppercaseFirst"
            :value="disease.id"
          />
        </el-select>
        <el-button v-waves class="mr-15 filter-item" type="primary" icon="el-icon-search" @click="handleFilterSpecies">
          {{ $t('general.search') }}
        </el-button>
        <el-button v-waves :loading="downloading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
          {{ $t('general.export') }}
        </el-button>
        <el-button v-if="checkPermission(['create specie'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="handleCreateSpecie">
          {{ $t('general.add') }}
        </el-button>
      </div>
      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">

        <el-table-column align="center" :label="$t('specie.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('specie.body')">
          <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('disease.diseases')" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.diseases && scope.row.diseases.length">
              <el-tag
                v-for="(specieDisease, index) in scope.row.diseases"
                :key="index"
                class="tag m-3"
                size="small"
                type="primary"
              >
                {{ diseases.find(disease => disease.id === specieDisease.id)?.name || $t('general.unknown') }}
                <el-tooltip v-if="diseases.find(disease => disease.id === specieDisease.id)?.description" class="item" effect="dark" :content="diseases.find(disease => disease.id === specieDisease.id)?.description||''" placement="top">
                  <i class="el-icon-info" />
                </el-tooltip>
              </el-tag>
            </div>
            <div v-else>
              <span>{{ $t('general.noData') }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="activeList!='corbeille' && checkPermission(['activate specie'])" align="center" :label="$t('general.status')" width="150">
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setSpecieStatus(scope.row.id,'active')"
            />
          </template>
        </el-table-column>

        <el-table-column v-if="checkRole(['Admin']) && (activeList=='corbeille' || query.keyword)" align="center" :label="$t('general.restaurer')" width="100">
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setSpecieStatus(scope.row.id,'visible')"
            />
          </template>
        </el-table-column>
        <el-table-column v-if="checkPermission(['edit specie','hide specie','delete specie'])" align="center" :label="1==1 ? $t('general.actions') : $t('general.suppressionDefinitive')" width="150">
          <template slot-scope="scope">
            <el-button v-if="scope.row.is_visible && checkPermission(['edit specie'])" type="primary" size="small" icon="el-icon-view" style="margin-right:10px;" @click="handleEditSpecie(scope.row.id);" />
            <el-button v-if="checkPermission(['hide specie','delete specie'])" slot="reference" type="danger" size="small" icon="el-icon-delete" style="margin-right:10px;" @click="handleDeleteSpecie(scope.row.id, scope.row.is_visible, scope.row.name);" />
          </template>
        </el-table-column>
      </el-table>

      <pagination v-if="total > 0" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getSpeciesList" />

      <!-- ======= SPECIE FORM ======= -->
      <el-dialog
        :title="editing ? $t('specie.edit') + ' ' + currentSpecie.name : $t('specie.AddSpecie')"
        :visible.sync="dialogCreateSpecie"
        :before-close="handleCloseSpecieCreateDraw"
        :loading="specieCreating"
        width="50%"
      >
        <div class="content-inputs">
          <el-form ref="specieForm" :rules="rules" :model="currentSpecie" label-position="left">
            <el-form-item :label="$t('specie.name')" prop="name">
              <el-input v-model="currentSpecie.name" />
            </el-form-item>
            <el-form-item :label="$t('specie.body')" prop="description">
              <el-input v-model="currentSpecie.description" type="textarea" />
            </el-form-item>
            <el-form-item
              :label="$t('disease.selectDiseasesTitle')"
              prop="diseases"
            >
              <el-select
                v-model="currentSpecie.diseases"
                multiple
                filterable
                clearable
                class="filter-item w-100"
                :placeholder="$t('disease.disease')"
              >
                <el-option
                  v-for="(disease, index) in diseases"
                  :key="index"
                  :label="disease.name | uppercaseFirst"
                  :value="disease.id"
                  :disabled="!disease.is_active"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="dialogCreateSpecie=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="specieCreating" @click="editing ? updateSpecie() : createSpecie()">
              {{ specieCreating ? $t('general.saving') : $t('general.save') }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- <el-drawer
        :title="$t('alert.alert')"
        :visible.sync="dialogCreateAlert"
        :before-close="handleCloseAlertCreateDraw"
        :loading="alertCreating"
        size="30%"
      >
        <div class="content-inputs" style="padding:30px">
          <div class="full-width">
            <div class="half-photo">
              <div class="demo-basic--circle">
                <div>
                  <el-avatar shape="square" :size="50" :src="currentAlert.author.avatar" />
                </div>
              </div>
            </div>
            <div class="half-right">
              <div class="in-td">
                <h4>{{ currentAlert.author.name }}</h4>
                <small>{{ currentAlert.author.email }}</small>
              </div>
            </div>
          </div>
          <el-divider />
          <div class="alert-subject margin-top">
            <h3>{{ $t('alert.subject') }}</h3>
            <p>
              {{ currentAlert.subject }}
            </p>
          </div>
          <div class="alert-body margin-top">
            <h3>{{ $t('alert.body') }}</h3>
            <p class="body-text">
              {{ currentAlert.body }}
            </p>
          </div>
          <el-divider />
          <el-card class="box-card">
            <el-form ref="alertForm" :rules="rules" :model="currentAlert" label-position="left">
              <el-form-item :label="$t('general.processing')" prop="processing">
                <el-radio-group v-model="currentAlert.processing">
                  <el-radio
                    v-for="(processing, idex) in processings"
                    :key="idex"
                    :label="processing"
                    :class="'radio-'+getprocessingColor(processing)"
                  > {{ processing | uppercaseFirst }} </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <span>
              <div style="text-align:right;">
                <el-button plain type="danger" @click="dialogCreateAlert=false">
                  {{ $t('general.close') }}
                </el-button>
                <el-button type="primary" :loading="alertCreating" @click="editing ? updateAlert() : createAlert()">
                  {{ alertCreating ? $t('general.saving') : $t('general.save') }}
                </el-button>
              </div>
            </span>
          </el-card>
        </div>
      </el-drawer> -->

      <!-- ======= END SPECIE FORM ======= -->

    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const specieResource = new Resource('species');
const diseaseResource = new Resource('diseases');
export default {
  name: 'SpeciesList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      diseases: [],
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      specieCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
        all: 0,
      },
      currentSpecie: {},
      dialogCreateSpecie: false,
      currentSpecieId: 0,
      rules: {
        name: [{ required: true, message: this.$t('specie.NameRequired'), trigger: 'blur' }],
        diseases: [
          {
            required: true,
            message: this.$t('disease.diseasesRequired'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
  },
  created() {
    this.getDiseasesList();
    this.resetNewSpecie();
    this.getSpeciesList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array){
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseSpecieCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    cancelSpecieForm() {
      this.$refs.SpecieCreationDrawer.closeDrawer();
    },
    initSearch(){
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
        all: 1,
      };
      this.activeList = 'disponibles';
      this.handleFilterSpecies();
    },
    async getDiseasesList() {
      this.loading = true;
      const query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
        all: 1,
      };

      // const { limit, page } = this.query;
      const { data } = await diseaseResource.list(query);
      this.diseases = data;
      /* this.diseases.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total; */
      this.loading = false;
    },
    async getSpeciesList() {
      this.loading = true;
      this.query.all = 0;
      const { limit, page } = this.query;
      const { data, meta } = await specieResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubSpeciesList(subUrl) {
      this.loading = true;
      const { data } = await specieResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterSpecies() {
      this.query.page = 1;
      this.query.all = 0;
      this.getSpeciesList();
    },
    handleCreateSpecie() {
      this.editing = false;
      this.resetNewSpecie();
      this.dialogCreateSpecie = true;
      this.$nextTick(() => {
        this.$refs['specieForm'].clearValidate();
      });
    },
    handleEditSpecie(id){
      this.editing = true;
      this.resetNewSpecie();
      this.currentSpecie = this.list.find(abonne => abonne.id === id);
      this.dialogCreateSpecie = true;
      this.$nextTick(() => {
        this.$refs['specieForm'].clearValidate();
      });
    },
    async setSpecieStatus(id, type){
      const data = await specieResource.get('toogle_' + type + '/' + id);
      if (data.success){
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteSpecie(id, visible, name) {
      this.$confirm(this.$t('specie.deleteWarn') + ' ' + name + '. ' + this.$t('general.deleteContinue'), 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning',
      }).then(() => {
        if (!visible && (checkRole(['Admin']) || checkPermission(['delete specie']))) {
          this.$swal({
            title: this.$t('general.SureQuestion'),
            text: this.$t('general.irrversibleMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('general.ouiSupprimer'),
          }).then((result) => {
            if (result.isConfirmed) {
              specieResource.destroy(id).then(response => {
                this.$message({
                  type: 'success',
                  message: this.$t('specie.suppressionEffectue'),
                });
                this.initSearch();
              }).catch(error => {
                console.log(error);
              });
            }
          });
        } else {
          this.setSpecieStatus(id, 'visible');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('general.suppressionAnnule'),
        });
      });
    },
    createSpecie() {
      this.$refs['specieForm'].validate((valid) => {
        if (valid) {
          this.specieCreating = true;
          specieResource
            .store(this.currentSpecie)
            .then(async(response) => {
              this.$message({
                message: this.$t('specie.NewSpecie') + ' ' + this.currentSpecie.name + ' ' + this.$t('specie.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentSpecieId = response.data.id;
              this.resetNewSpecie();
              this.dialogCreateSpecie = false;
              this.handleFilterSpecies();
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.specieCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateSpecie() {
      this.$refs['specieForm'].validate((valid) => {
        if (valid) {
          this.specieCreating = true;
          specieResource.update(this.currentSpecie.id, this.currentSpecie).then(response => {
            this.resetNewSpecie();
            this.handleFilterSpecies();
            this.$message({
              message: this.$t('specie.isupdatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            this.dialogCreateSpecie = false;
            this.editing = false;
          })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.specieCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewSpecie() {
      this.currentSpecie = {
        name: '',
        description: '',
      };
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['ID', this.$t('specie.name'), this.$t('specie.body'), this.$t('disease.disease')];
        const filterVal = ['id', 'name', 'description', 'diseases'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Species list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
    width: 70% !important;
    float: none !important;
    text-align: left !important;
    padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
